import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { NGXLogger as LoggerService } from "ngx-logger";

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(
        private logger: LoggerService,
        private http: HttpClient
    ) {
    }

    getTranslation(scopeSlashLang: string) {
        scopeSlashLang = scopeSlashLang.toLowerCase()
        const scopeArray = this.getScope(scopeSlashLang)
        const lang = this.getLang(scopeSlashLang)
        if (scopeArray) {
            let scopeString = scopeArray.join('.')
            scopeString = scopeString.replace('new', '') // this is an ugly hack to avoid  we get erorrs on polltemplates like "scheduleNew" - otherwise we would need to create empty files for those
            return this.http.get<Translation>(`assets/locale/${lang}/${scopeArray[0]}/${scopeString}.${lang}.dic.json`);
        } else {
            // Root scope (just the language key, e.g. "en"): there is no file for it, every text lives in a scope
            // and Transloco merges the scopes into the language translation anyway. A request would get the SPA
            // shell (200 text/html) via the hosting rewrite and fail at the JSON parse. No key is read without a
            // scope (checked 2026-10-30), so answer with an empty translation and save the request.
            return of({});
        }
    }

    /**
     *
     * @param scopeSlashLang  a string like "landing-pages/schedule/en"  or  "landing-pages/en" also just the language key  for example "en"
     * @returns the scope - in the example above, ['templates', 'schedule'], ['landing-pages', 'schedule'] or  ['landing-pages'] if there is no scope but just the language key (which is always the string behind the last /), return null
     */
    getScope(scopeSlashLang: string): string[] | null {
        const parts = scopeSlashLang.split('/');
        if (parts.length > 1) {
            return parts.slice(0, -1);
        }
        return null;
    }

    /**
     *
     * @param scopeSlashLang  a string like "landing-pages/schedule/en"  or  "landing-pages/en" also just the language key  for example "en"
     * @returns the language key  (which is always the string behind the last /) - in the examples above "en"
     */
    getLang(scopeSlashLang: string): string {
        const parts = scopeSlashLang.split('/');
        return parts[parts.length - 1];
    }
}
